var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "emergencies" },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            { staticClass: "column is-3" },
            [_c("app-sidebar"), _vm._v(" "), _c("onboarding")],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "column is-9" },
            [
              !_vm.currentOffice
                ? _c("div", { staticClass: "section mt-5 mb-10" }, [
                    _c("p", { staticClass: "is-aligned-center" }, [
                      _vm._v(_vm._s(_vm.$t("no_office_selected")))
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.offices, function(office) {
                return _vm.currentOffice == office.id
                  ? _c("div", { key: office.id, staticClass: "mt-7" }, [
                      _c("div", { staticClass: "is-clearfix mb-3" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "button is-primary is-outlined is-pulled-right has-icon",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.refreshEmergencies()
                              }
                            }
                          },
                          [
                            _c("b-icon", { attrs: { icon: "refresh" } }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("refresh_button_label")))
                            ])
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      !_vm.doctor.isCertified
                        ? _c("div", [
                            _c("div", { staticClass: "section p-4 mb-10" }, [
                              _c("p", { staticClass: "has-text-center" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("doctor_not_certified_warning"))
                                )
                              ])
                            ])
                          ])
                        : _c(
                            "div",
                            [
                              Object.keys(_vm.emergencies).length == 0
                                ? _c(
                                    "div",
                                    { staticClass: "section p-4 mb-10" },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "has-text-center" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "no_emergencies_placeholder"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.emergencies, function(emergency, key) {
                                return _c(
                                  "article",
                                  {
                                    key: key,
                                    staticClass: "card",
                                    attrs: { id: "emergency-" + key }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "card-header clickable",
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.selectEmergency(
                                              key,
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "card-header-title" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "media" },
                                              [
                                                emergency.pictures.length > 0
                                                  ? _c(
                                                      "figure",
                                                      {
                                                        staticClass:
                                                          "image thumbnail is-128x128 is-inline-block mr-3"
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src:
                                                              emergency
                                                                .pictures[0],
                                                            alt: "Image Preview"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "media-content"
                                                  },
                                                  [
                                                    _c(
                                                      "h3",
                                                      {
                                                        staticClass:
                                                          "title is-6"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "patient_header",
                                                              {
                                                                age:
                                                                  emergency.patientAge,
                                                                locality:
                                                                  emergency.locality
                                                              }
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "h4",
                                                      {
                                                        staticClass:
                                                          "subtitle is-7"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.timeAgo(
                                                              emergency.dateTimeCreated,
                                                              "X"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          { staticClass: "card-header-icon" },
                                          [
                                            _c("b-icon", {
                                              attrs: {
                                                icon:
                                                  _vm.openedEmergency == key
                                                    ? "arrow-drop-down"
                                                    : "arrow-drop-up"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.openedEmergency == key,
                                            expression: "openedEmergency == key"
                                          }
                                        ]
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "card-content" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "content" },
                                              [
                                                _c(
                                                  "h5",
                                                  { staticClass: "title is-5" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "patient_symptoms_title"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "columns is-multiline"
                                                  },
                                                  _vm._l(
                                                    emergency.symptoms,
                                                    function(symptom) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "column is-6"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "field"
                                                            },
                                                            [
                                                              _c("label", {
                                                                domProps: {
                                                                  textContent: _vm._s(
                                                                    symptom.question
                                                                  )
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "is-size-7"
                                                                },
                                                                [
                                                                  _c("strong", {
                                                                    domProps: {
                                                                      textContent: _vm._s(
                                                                        symptom.answer
                                                                      )
                                                                    }
                                                                  })
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _vm._v(" "),
                                                _c("hr"),
                                                _vm._v(" "),
                                                _c(
                                                  "h5",
                                                  { staticClass: "title is-5" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "patient_information_title"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "columns is-multiline"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "column is-4"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "field"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "patient_age_label"
                                                                  )
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "is-size-7"
                                                              },
                                                              [
                                                                _c("strong", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      emergency.patientAge
                                                                        ? emergency.patientAge
                                                                        : "N/A"
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "column is-4"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "field"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "patient_locality_label"
                                                                  )
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "is-size-7"
                                                              },
                                                              [
                                                                _c("strong", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      emergency.locality
                                                                        ? emergency.locality
                                                                        : "N/A"
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "column is-4"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "field"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "patient_zip_code_label"
                                                                  )
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "is-size-7"
                                                              },
                                                              [
                                                                _c("strong", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      emergency.zipCode
                                                                        ? emergency.zipCode
                                                                        : "N/A"
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("hr"),
                                                _vm._v(" "),
                                                _c(
                                                  "h5",
                                                  {
                                                    staticClass:
                                                      "title is-5 mb-0"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("pictures_title")
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                emergency.pictures.length == 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "message is-warning mt-3"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "message-body"
                                                          },
                                                          [
                                                            _c("b-icon", {
                                                              attrs: {
                                                                icon: "alert"
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "no_pictures_placeholder"
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm._l(
                                                  emergency.pictures,
                                                  function(picture) {
                                                    return _c(
                                                      "figure",
                                                      {
                                                        staticClass:
                                                          "image thumbnail is-128x128 is-inline-block",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.showPicture(
                                                              picture
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src: picture,
                                                            alt: _vm.$t(
                                                              "picture_alt"
                                                            )
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  }
                                                ),
                                                _vm._v(" "),
                                                _c("hr"),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "button is-primary has-icon",
                                                    attrs: {
                                                      disabled: !_vm.loadedAvailabilities
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.preventDefault()
                                                        return _vm.acceptEmergency(
                                                          key
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("b-icon", {
                                                      attrs: {
                                                        icon: "check-circle"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "accept_emergency_button_label"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              2
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                    ])
                  : _vm._e()
              })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c("accept-emergency-form", {
        attrs: {
          active: _vm.showAcceptModal,
          emergency: _vm.selectedEmergency,
          availabilities: _vm.availabilities
        },
        on: {
          close: function($event) {
            return _vm.toggleEmergencyForm(false)
          },
          accepted: function($event) {
            return _vm.refresh()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c9acf8f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c9acf8f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Doctor/Emergencies.vue
// module id = 642
// module chunks = 1